import { ConversationEntity } from 'widget_main/store/types';

export const getFilteredConversations = (
  conversationsList: ConversationEntity[],
  noHistory: boolean,
  unreadConversationIds: string[] = [],
) => {
  // Filter out conversations that have been merged into other conversations
  const filteredConversations = conversationsList.filter(
    (conversation) => !conversation.movedToConversationId,
  );

  if (noHistory) {
    return filteredConversations.filter(
      (conversation) =>
        !conversation.ended ||
        unreadConversationIds.some((c) => c === conversation.conversationId),
    );
  }
  return filteredConversations;
};
